"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listMarkerStyles = exports.markerShapeStyles = void 0;
const lit_1 = require("lit");
/** 원 안에 기호를 가운데 두는 마커 골격. 지름은 --marker-size로, 색은 얹는 쪽이 정한다. */
exports.markerShapeStyles = (0, lit_1.css) `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--marker-size);
  height: var(--marker-size);
  border-radius: 50%;
  font-size: 10px;
`;
exports.listMarkerStyles = (0, lit_1.css) `
  :host {
    --marker-size: var(--size-16);
    --list-marker-background-color: var(--background-strong-color);
    --list-marker-text-color: var(--foreground-on-strong-color);

    ${exports.markerShapeStyles};
    background: var(--list-marker-background-color);
    color: var(--list-marker-text-color);
  }

  svg {
    width: 0.5rem;
    height: 0.5rem;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlzdC1tYXJrZXIuc3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibGlzdC1tYXJrZXIuc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUF5QjtBQUV6QiwrREFBK0Q7QUFDbEQsUUFBQSxpQkFBaUIsR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7O0NBU25DLENBQUE7QUFFWSxRQUFBLGdCQUFnQixHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7TUFNN0IseUJBQWlCOzs7Ozs7Ozs7Q0FTdEIsQ0FBQSJ9